// extracted by mini-css-extract-plugin
export default {"tooltip":"g6X8"};